// Shared admin strings (buttons, statuses, generic labels) used across pages.
const m: Record<string, string> = {
  'Enregistrer': 'Save',
  'Annuler': 'Cancel',
  'Fermer': 'Close',
  'Supprimer': 'Delete',
  'Modifier': 'Edit',
  'Ajouter': 'Add',
  'Confirmer': 'Confirm',
  'Valider': 'Confirm',
  'Retour': 'Back',
  'Voir': 'View',
  'Copier': 'Copy',
  'Copié ✓': 'Copied ✓',
  'Chargement…': 'Loading…',
  'Aucun résultat': 'No results',
  'Rechercher': 'Search',
  'Terminé': 'Done',
  'Aujourd’hui': 'Today',
  '7 jours': '7 days',
  '7 derniers jours': 'Last 7 days',
  '30 jours': '30 days',
  '30 derniers jours': 'Last 30 days',
  'Tout': 'All',
  // ── Date-range picker ──
  "Aujourd'hui": 'Today',
  'Hier': 'Yesterday',
  '14 derniers jours': 'Last 14 days',
  'Ce mois-ci': 'This month',
  'Mois dernier': 'Last month',
  'Maximum': 'Maximum',
  'Appliquer': 'Apply',
  'Raccourcis': 'Shortcuts',
  'Heure de Casablanca': 'Casablanca time',
  'Depuis': 'Since',
  "Jusqu'au": 'Until',
  'Sélectionnez une période': 'Select a period',
  'Mois précédent': 'Previous month',
  'Mois suivant': 'Next month',
  'Date': 'Date',
  'Statut': 'Status',
  'Client': 'Customer',
  'Prix': 'Price',
  'Total': 'Total',
  'Solo': 'Solo',
  'Duo': 'Duo',
  'Trio': 'Trio',
  // order statuses
  'En attente': 'Pending',
  'Album soumis': 'Album submitted',
  'En revue': 'In review',
  'En production': 'In production',
  'Imprimé': 'Printed',
  'Expédié': 'Shipped',
  'Livré': 'Delivered',
  'Annulé': 'Cancelled',
  'En redo': 'In redo',
};
export default m;
